import { WordpressContent } from "src/types/wordpress";

export const wordpressDataSortByDate = <T>(
  content: WordpressContent<T>[]
): WordpressContent<T>[] => {
  return content
    .slice()
    .sort(
      (left, right) =>
        new Date(right.date).getTime() - new Date(left.date).getTime()
    );
};
